export default __webpack_public_path__ + "static/media/reference-impreso-via-publica.0b44fc0c.svg";